import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: none;\n  margin: 30px 0;\n'], ['\n  display: none;\n  margin: 30px 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 45px;\n  margin-bottom: 10px;\n\n  @media (max-width: ', ') {\n    font-size: 32px;\n    margin-bottom: 8px;\n  }\n'], ['\n  text-align: center;\n  font-size: 45px;\n  margin-bottom: 10px;\n\n  @media (max-width: ', ') {\n    font-size: 32px;\n    margin-bottom: 8px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: 600;\n  margin-bottom: 6px;\n\n  @media (max-width: ', ') {\n    font-size: 14px;\n  }\n'], ['\n  text-align: center;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: 600;\n  margin-bottom: 6px;\n\n  @media (max-width: ', ') {\n    font-size: 14px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-weight: 400;\n'], ['\n  font-weight: 400;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 40px;\n  line-height: 1;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: ', ';\n'], ['\n  text-align: center;\n  font-size: 40px;\n  line-height: 1;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 30px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  line-height: 1.2;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n'], ['\n  text-align: center;\n  font-size: 30px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  line-height: 1.2;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 30px;\n  margin: 0 40px;\n  line-height: 1.4;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n'], ['\n  text-align: center;\n  font-size: 30px;\n  margin: 0 40px;\n  line-height: 1.4;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n']);

import styled from 'styled-components';

export var StyledSuccessMessage = styled.div(_templateObject);

export var StyledLargeText = styled.h4(_templateObject2, function (props) {
  return props.theme.mobileWidth;
});

export var StyledSmallText = styled.p(_templateObject3, function (props) {
  return props.theme.mobileWidth;
});

export var StyledSmallTextThin = styled(StyledSmallText)(_templateObject4);

export var StyledDiscountCode = styled.p(_templateObject5, function (props) {
  return props.theme.dormifyPink;
});

export var StyledSmsTitle = styled.p(_templateObject6, function (props) {
  return props.theme.mobileWidth;
});

export var StyledSmsText = styled.p(_templateObject7, function (props) {
  return props.theme.mobileWidth;
});